export const STATUS = {
  UNINITIALIZED: 'edrolo/bySchoolClass/UNINITIALIZED',
  LOADING: 'edrolo/bySchoolClass/LOADING',
  RELOADING: 'edrolo/bySchoolClass/RELOADING',
  READY: 'edrolo/bySchoolClass/READY',
  FAILURE: 'edrolo/bySchoolClass/FAILURE',
};

export { FAILURE_REASON } from 'edrolo/domains/net';

export const COURSE_FEATURE = {
  LESSON_QUESTIONS: 'LESSON_QUESTIONS',
  PREMIUM_ATTACHMENTS: 'PREMIUM_ATTACHMENTS',
};

export const NODE_TYPE = {
  COURSE: 'COURSE',
  SECTION: 'SECTION',
  LESSON: 'LESSON',
  EXAM: 'EXAM',
  ATTACHMENT: 'ATTACHMENT',
};

export const SCHOOL_CLASS_TYPE = {
  normal: 'N',
  complimentary: 'C',
  teacher_trial: 'TT',
  student_trial: 'ST',
};

//
// backoff and retry settings
//

// ms, and will increase exponentially on each failure, e.g. 100 =  200ms, 400ms, 800ms, 1600
export const NETWORK_BACKOFF_INTERVAL = 200;
export const NETWORK_RETRY_COUNT = 5;
